import { Box, styled, Typography } from '@mui/material';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled(Box)`
  display: flex;
  margin-top: 40px;
  border-radius: 8px;

  @media (max-width: 1023px) {
    flex-direction: column;

    &.no-margin-top {
      margin-top: 0px;
    }
  }
`;

export const FirstRow = styled(Row)``;

export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 16px;
`;

export const DesktopView = styled('div')`
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const MobileView = styled('div')`
  display: none;
  @media (max-width: 1023px) {
    display: block;
  }
`;
